import React from 'react';

const BdAddress = () => {
    return (
        <div className='border p-8 bg-orange-300 w-full'>
            <div className='flex justify-between items-center'>
                <div>
                    <h1>Street: Bagbari .</h1>
                    <h1>City: Sylhet</h1>
                    <h1>Phone: +8801733735734</h1>
                    <h1>Email: webdeveloperroni@gmail.com</h1>
                </div>
                <div>
                    <h1 className='text-2xl'>BANGLADESH OFFICE</h1>
                </div>
            </div>
        </div>
    );
};

export default BdAddress;